<template>
    <div id="app">
        <section class="hero is-info">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">
                        4E Power Builder
                    </h1>
                    <h2>
                        Create Roll20 Power Macros Easily
                    </h2>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="columns">
                    <div class="column is-two-thirds">
                        <input-form />
                    </div>  
                    <div class="column is-one-third">                        
                        <power-card />
                        <macro-output />
                    </div>
                </div>
            </div>
        </section>       
    </div>
</template>

<script>
import InputForm from './components/InputForm.vue';
import PowerCard from './components/PowerCard.vue';
import MacroOutput from './components/MacroOutput.vue';
import { mapState } from 'vuex';

export default {
    name: 'app',
    components: {
        'input-form': InputForm,
        'power-card': PowerCard,
        'macro-output': MacroOutput,
    },
    computed: {
        ...mapState([
            'test',
        ]),
    },
}
</script>